import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// The one box every text control shares: Input, Select and Textarea compose
// it. If we later need "error", "success", or size variants, swap to
// styleVariants the same way Button does.
export const input = style({
  display: "block",
  width: "100%",

  fontFamily: vars.font.body,
  fontSize: vars.fontSize.md,
  lineHeight: vars.lineHeight.normal,
  color: vars.color.textDefault,
  backgroundColor: vars.color.surface,

  paddingBlock: vars.space.sm,
  paddingInline: vars.space.md,
  borderRadius: vars.radius.lg,
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: vars.color.borderSubtle,

  outline: "none",

  selectors: {
    "&::placeholder": {
      color: vars.color.textSubtle,
    },
    "&:hover:not(:disabled):not(:read-only)": {
      borderColor: vars.color.borderStrong,
    },
    // The global base.css :focus-visible rule gives us the focus shadow;
    // we just need to bump the border color so the control reads as
    // clearly "active" against any background.
    "&:focus-visible": {
      borderColor: vars.color.primary,
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
      backgroundColor: vars.color.surfaceMuted,
    },
    // :user-invalid is the modern "the user has interacted with this
    // and it's still invalid per HTML5 constraint validation" state.
    // Better than :invalid which triggers on pristine required fields.
    "&:user-invalid": {
      borderColor: vars.color.danger,
    },
    // A refusal the API sent back for this control, which Field wires.
    '&[aria-invalid="true"]': {
      borderColor: vars.color.danger,
    },
  },
});
